import api, {
  onUnauthorized,
  tokenStore,
  clearClientAuthState,
  getTokenExpiresAt,
  refreshAccessToken,
  hasClientAuthState,
  isUnauthorizedError,
  getHttpStatus,
} from "./client";

export const setAccessToken = (
    token: string | null,
    expiresAt?: number | null
) => {
  tokenStore.set(token, expiresAt ?? null);
};

export const getAccessToken = () => {
  return tokenStore.get();
};

export {
  onUnauthorized,
  tokenStore,
  clearClientAuthState,
  getTokenExpiresAt,
  refreshAccessToken,
  hasClientAuthState,
  isUnauthorizedError,
  getHttpStatus,
};

export default api;
